<template>
  <v-col cols="12" md="12">
    <v-row>
      <v-col cols="12" md="12">
          <h2>Advance Search</h2>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" md="12">
            <v-row>
              <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="Universal RTS Number #"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.universal_rts_number"
                ></v-text-field>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="RTS Number #"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.rts"
                ></v-text-field>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="PPS Number #"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.pps"
                ></v-text-field>
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="Client Ref #"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.client_ref"
                ></v-text-field>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                    <v-menu
                    v-model="fromDate"
                    :close-on-content-click="false"
                    :nudge-right="20"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        label="From Date"
                        readonly
                        :value="frmDateVal"
                        v-on="on"
                        solo
                        hide-details="true"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        locale="en-in"
                        v-model="frmDate"
                        no-title
                        @input="fromDate = false"
                    ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <v-menu
                    v-model="orderToDate"
                    :close-on-content-click="false"
                    :nudge-right="20"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        label="To Date"
                        readonly
                        :value="orderToDateVal"
                        v-on="on"
                        solo
                        hide-details="true"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        locale="en-in"
                        v-model="ordToDate"
                        no-title
                        @input="orderToDate = false"
                    ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <v-select
                label="Client"
                solo
                hide-details="true"
                multiple
                :items="clients"
                item-text="name"
                item-value="id"
                v-model="search.client"
                >
                </v-select>
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <v-select
                :items="products"
                item-text="name"
                item-value="id"
                label="Product"
                solo
                hide-details="true"
                multiple
                v-model="search.product"
                ></v-select>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <AutoComplete ref="autocomplete" :default="null" :solo=true label="State" itemText="name" url="states/?slug__contains=" field="state" type="foriegn" @clicked="getAutoCompleteData" />
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <AutoComplete ref="autocompletecounty" :default="null" :solo=true label="County" itemText="name" :url="countyURL" field="county" type="foriegn" @clicked="getAutoCompleteData" />
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="Address"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.address"
                ></v-text-field>
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <v-text-field
                    label="Borrower"
                    single-line
                    solo
                    hide-details="true"
                    v-model="search.borrower"
                ></v-text-field>
                </v-col>
                <v-col cols="2" sm="2" class="advance-col">
                <v-select
                    label="Order Stage"
                    single-line
                    solo
                    hide-details="true"
                    multiple
                    :items="orderStatusList"
                    item-value="name"
                    item-text="name"
                    v-model="search.order_stage"
                ></v-select>
                </v-col>

                <v-col cols="2" sm="2" class="advance-col">
                <v-select
                :items="vendors"
                item-value="id"
                item-text="first_name"
                label="Vendor"
                solo
                hide-details="true"
                v-model="search.vendor"
                ></v-select>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <v-row class="justify-center">
        <v-btn class="ma-2" tile color="primary" dark @click="findSearch" :loading="ploading">Filter</v-btn>
        <v-btn class="ma-2" tile color="teal lighten-2" dark @click="resetSearch">Reset</v-btn>
        <v-btn class="ma-2" tile color="primary" dark @click="cancelSearch">Cancel</v-btn>
    </v-row>
    <v-row>
      <v-col  cols="12" md="12" class="d-flex align-center" id="datatableContainer">
        <dataTable :exportURL="exportURL" ref="dataTable" v-show="isHidden" @pageChanged="paginateOrder" :dataTableData="dataTableData" :headers="headers" :loading="loading" />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
// @ advance search component
import dataTable from '@/components/dataTable.vue'
import API_URL from '@/common/config'
import AutoComplete from '@/components/autoComplete.vue'
import { GETCLIENTLIST, GETPRODUCTLIST, GETVENDORLIST, GETORDERSTATUSLIST, GETSEARCHORDER_V2 } from '@/store/actions.type'
export default {
  name: 'AdvanceSearch',
  components: {
    dataTable,
    AutoComplete
  },
  data () {
    return {
      dataTableData: {
        count: 0,
        next: null,
        previous: null,
        results: []
      },
      exportURL: null,
      baseAPIUrl: API_URL,
      loading: false,
      ploading: false,
      countyURL: null,
      itemsPerPage: 10,
      page: 1,
      isHidden: false,
      customerData: null,
      fromDate: false,
      frmDate: null,
      orderToDate: false,
      ordToDate: null,
      clients: [],
      products: [],
      vendors: [],
      orderStatusList: [],
      search: {
        rts: null,
        client_ref: null,
        client: null,
        product: null,
        state: null,
        county: null,
        address: null,
        borrower: null,
        order_stage: null,
        vendor: null
      },
      headers: [
        {
          text: 'Universal RTS Number',
          align: 'left',
          sortable: false,
          value: 'universal_rts_number'
        },
        { text: 'Client', value: 'client.name', sortable: false },
        { text: 'Client Ref#', value: 'client_reference', sortable: false },
        { text: 'Address', value: 'address', sortable: false },
        { text: 'County', value: 'address.county.name', sortable: false },
        { text: 'State', value: 'address.state.name', sortable: false },
        { text: 'Borrower', value: 'first_borrower', sortable: false },
        { text: 'Order Date', value: 'created_on', sortable: false },
        { text: 'Due Date', value: 'due_on', sortable: false },
        { text: 'Vendor', value: 'vendor', sortable: false },
        { text: 'Status', value: 'status.name', sortable: false },
        { text: 'Product', value: 'product.name', sortable: false },
        { text: 'On Hold', value: 'on_hold', sortable: false }
      ]
    }
  },
  computed: {
    frmDateVal () {
      return this.frmDate
    },
    orderToDateVal () {
      return this.ordToDate
    }
  },
  mounted () {
    console.log(GETCLIENTLIST)
    let clientListPayload = {
      page_size: 100000
    }
    this.$store.dispatch(GETCLIENTLIST, clientListPayload)
      .then(response => {
        if (response.hasOwnProperty('results')) {
          this.clients = response.results
        } else {
          this.clients = []
        }
      })
    this.$store.dispatch(GETPRODUCTLIST, clientListPayload)
      .then(response => {
        if (response.hasOwnProperty('results')) {
          this.products = response.results
        } else {
          this.products = []
        }
      })
    this.$store.dispatch(GETVENDORLIST, clientListPayload)
      .then(response => {
        if (response.hasOwnProperty('results')) {
          this.vendors = response.results
        } else {
          this.vendors = []
        }
      })
    this.$store.dispatch(GETORDERSTATUSLIST, clientListPayload)
      .then(response => {
        if (response.hasOwnProperty('results')) {
          this.orderStatusList = response.results
        } else {
          this.orderStatusList = []
        }
      })
  },
  methods: {
    paginateOrder (conf) {
      // console.log(conf.page)
      this.itemsPerPage = conf.itemsPerPage
      this.page = conf.page
      this.searchOrders()
    },
    getAutoCompleteData (data) {
      if (data.__field === 'state') {
        this.search.stateName = data.id
        this.countyURL = `counties/?state__id=${data.id}`
      } else if (data.__field === 'county') {
        this.search.county = data.id
      }
    },
    cancelSearch: function () {
      this.$router.push('/')
    },
    resetSearch: function () {
      console.log('reset clicked')
      this.dataTableData.results = []
      this.page = 1
      this.search = {
        rts: null,
        client_ref: null,
        client: null,
        product: null,
        stateName: null,
        county: null,
        address: null,
        borrower: null,
        order_stage: null,
        vendor: null
      }
      this.orderSendDate = null
      this.oderAssignDateVal = null
      this.frmDate = null
      this.ordToDate = null
      this.$refs.dataTable.options.page = 1
      this.$refs.autocomplete.model = ''
      this.$refs.autocompletecounty.model = null
      this.searchOrders()
    },
    findSearch: function () {
      this.page = 1
      this.$refs.dataTable.options.page = 1
      this.ploading = true
      this.searchOrders()
    },
    searchOrders: function () {
      document.getElementById('datatableContainer').scrollIntoView({ behavior: 'smooth' })
      this.loading = true
      this.isHidden = true
      let orderPayload = {
        page: this.page,
        page_size: this.itemsPerPage
      }
      if (this.search.pps) {
        orderPayload['id'] = this.search.pps
      }
      if (this.search.universal_rts_number) {
        orderPayload['universal_rts_number'] = this.search.universal_rts_number
      }
      if (this.search.rts) {
        orderPayload['old_rts_no'] = this.search.rts
      }
      if (this.search.client_ref) {
        orderPayload['client_reference__contains'] = this.search.client_ref
      }
      if (this.frmDate) {
        orderPayload['created_on__gte'] = this.frmDate + 'T00:00:00'
      }
      if (this.ordToDate) {
        orderPayload['created_on__lte'] = this.ordToDate + 'T23:59:59'
      }
      if (this.search.client) {
        orderPayload['client__id__in'] = this.search.client.join(',')
      }
      if (this.search.product) {
        orderPayload['product__id__in'] = this.search.product.join(',')
      }
      if (this.search.stateName) {
        orderPayload['address__state__id'] = this.search.stateName
      }
      if (this.search.county) {
        orderPayload['address__county__id'] = this.search.county
      }
      if (this.search.address) {
        orderPayload['address__street__icontains'] = this.search.address
      }
      if (this.search.borrower) {
        orderPayload['first_borrower'] = this.search.borrower
      }
      if (this.search.order_stage) {
        orderPayload['status__name__in'] = this.search.order_stage.join(',')
      }
      if (this.search.vendor) {
        orderPayload['vendor__id__in'] = this.search.vendor.join(',')
      }
      var queryString = Object.keys(orderPayload).map(key => key + '=' + orderPayload[key]).join('&')
      this.$store.dispatch(GETSEARCHORDER_V2, queryString)
        .then(response => {
          this.orderList = response.results
          this.dataTableData = response
          this.exportURL = `${this.baseAPIUrl.BASE_API_URL}/download_orders/?${queryString}`
          this.loading = false
          this.ploading = false
        })
    }
  },
  watch: {
  }
}
</script>
<style>
.advance-col{
    padding-bottom:0px;
}
.v-input__slot, .v-text-field__details{
    margin-bottom:0px;
}
#datatableContainer .row .d-flex .v-data-table--fixed-height .v-data-table__wrapper{
  height:400px !important;
}
</style>
